import { inject, Pipe, PipeTransform } from '@angular/core';
import { VariablesService } from '@services/variables/variables.service';


@Pipe({
  name: 'translatePipe',
  standalone: true
})
export class CustomTranslatePipe implements PipeTransform {
  private vars = inject(VariablesService);

  transform(val) {
    return this.vars.getTranslatedJsonObs(val);
  }
}
